import { Box, Grid, Button, Typography, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import FixedSizeDialog from "components/fixedSizeDialog";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import moment from "moment";
import UploadCreateForm from "../forms/createUploadForm";
import DownloadIcon from "@mui/icons-material/Download";
import { Upload } from "@mui/icons-material";
import { useGetProductUploadList } from "api/hooks/uploads";
import { fileURL, requester } from "api/pesabackend";

export default function ProductUploadsTable({ setIsSuccess, setIsFailed }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { productUploadList, isLoadingProductUploadList, setNewProductUploadData } = useGetProductUploadList(business_branch_id);
  const [open, setOpen] = useState(false);

  const saveUpload = async (values, onSubmitProps) => {

    const savedItemResponse = await requester.post(`/uploads/products`, values,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
    );

    if (savedItemResponse.data.status === 201) {
      setOpen(false);
      setNewProductUploadData(true);
      onSubmitProps.resetForm();
      setIsSuccess(true);
    }

    if (savedItemResponse.data.status === 400) {
      setIsFailed(true);
    }
  };

  const handleClickDownloadTemplate = async () => {
    const _response = await requester.get(`/uploads/initial_stock/generate?business_branch_id=${business_branch_id}&sample=0`);
    if (_response.status === 200) {
      const a = document.createElement("a");
      a.href = `${fileURL}/${_response.data.data.file_url}`;
      a.download = _response.data.data.name;
      a.click();
    }
  }
  const handleClickUploadOpen = async (e) => {
    setOpen(true);
  };

  const handleClickUploadClose = async (e) => {
    setOpen(false);
  };


  const handleClickView = async (file_data) => {
    navigate("/productUploadProgress", { state: file_data });
  };


  return (
    <Box>
      <Typography variant="h3">Uploaded Products List</Typography>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <Grid xs={3}>
          </Grid>

          <Grid xs={6}>
          </Grid>
          <Grid xs={3} sx={{ textAlign: "right" }}>
            <Button variant="contained" endIcon={<DownloadIcon />} onClick={() => handleClickDownloadTemplate()}>
              DOWLOAD TEMPLATE
            </Button>
            <Button sx={{ mx: "5px" }} endIcon={<Upload />} variant="contained" onClick={() => handleClickUploadOpen()}>
              UPLOAD FILE
            </Button>
            <FixedSizeDialog
              dialogHeading="Upload File Form"
              open={open}
              handleClose={handleClickUploadClose}
              negativeResponse="Cancel"
              maxWidth={"md"}
              scroll={"body"}
              content={
                <Box
                  p="1rem"
                  borderRadius="0.5rem"
                >
                  <UploadCreateForm setOpen={setOpen} saveItem={saveUpload} />
                </Box>
              }
            />
          </Grid>
        </Grid>
      </Box>

      <Box>
        <ReportTable
          columns={[
            { label: "Date Uploaded" },
            { label: "File Status" },
            { label: "Number of Records" },
            { label: "Uploaded By" },
            { label: "Actions", align: "center" },
          ]}
          rows={productUploadList}
          loading={isLoadingProductUploadList}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id} index={index}>
              <RCell>{moment(row.date_added).format("LLL")}</RCell>
              <RCell>{row.processed_status ? "PROCESSED" : "NOT PROCESSED"}</RCell>
              <RCell>{row.number_of_rows}</RCell>
              <RCell>
                {row.uploaded_by.first_name} {row.uploaded_by.last_name}
              </RCell>
              <RCell align="center">
                <Button
                  value={row.id}
                  size="small"
                  onClick={() => handleClickView(row)}
                >
                  View Details
                </Button>
              </RCell>
            </RRow>
          )}
        />
      </Box>
    </Box>
  );
}
